import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import cn from "classnames";
const DiagonalWidgetBackground = ({ imageUrl, imageAltText, children, className, hideImg }) => {
    const bgImg = useRef();
    useEffect(() => {
        if (bgImg && bgImg.current) {
            if (!hideImg && imageUrl) {
                bgImg.current.style.background = `url("${imageUrl}")`;
                bgImg.current.style.backgroundSize = "cover";
            }
            else {
                bgImg.current.style.background = null;
                bgImg.current.style.backgroundSize = "auto";
            }
        }
    }, [bgImg, hideImg]);
    return (_jsx("div", { ref: bgImg, role: "img", "aria-label": imageAltText, className: cn("diagonal-widget-background", !imageUrl && "diagonal-widget-background--no-img", className), children: children }));
};
export default DiagonalWidgetBackground;
